/**
 * چک‌لیستِ «نوع همکاری» — همان‌جا که تیک می‌خورد، همان با پرسنل حساب می‌شود.
 *
 * دو جا استفاده می‌شود: داخلِ فرمِ پرسنل، و در مودالِ ویرایشِ سریع از روی لیست.
 * منطقِ ناسازگاری و ترجمه به ستون‌های دیتابیس در `utils/collaboration.js` است
 * تا این فایل فقط نمایش باشد.
 */
import React from "react";
import { Checkbox, Space, Tag, Tooltip, Typography } from "antd";
import Alert from "./GxAlert";
import { COLLAB_GROUPS, conflictOf, toggle } from "../utils/collaboration";

const { Text } = Typography;

export default function CollaborationPicker({ value, onChange, secondaryRoles = [] }) {
  const checked = value || new Set();
  const conflict = conflictOf(checked);
  // «خارج از حقوق» بقیه را بی‌اثر می‌کند؛ خاکستری‌شان می‌کنیم تا کاربر گمراه نشود
  const muted = checked.has("excluded");
  // «مدیر کارگاه» فعلاً پایهٔ حقوق ندارد؛ ثابت/کارمزد کنارش بی‌معنی است
  const managerMutes = checked.has("manager") ? ["fixed", "piece"] : [];

  return (
    <div>
      {COLLAB_GROUPS.map((g) => (
        <div key={g.key} style={{ marginBottom: 12 }}>
          <Text strong style={{ fontSize: 13 }}>{g.label}</Text>
          {g.hint && (
            <Text type="secondary" style={{ fontSize: 11, display: "block", marginBottom: 4 }}>
              {g.hint}
            </Text>
          )}
          <Space direction="vertical" size={2} style={{ marginTop: 4 }}>
            {g.items.map((it) => (
              <Tooltip key={it.key} title={it.help} placement="left">
                <Checkbox
                  checked={checked.has(it.key)}
                  disabled={(muted && it.key !== "excluded") || managerMutes.includes(it.key)}
                  onChange={(e) => onChange(toggle(checked, it.key, e.target.checked))}>
                  {it.label}
                </Checkbox>
              </Tooltip>
            ))}
          </Space>
        </div>
      ))}

      {secondaryRoles.length > 0 && (
        <div style={{ marginBottom: 12 }}>
          <Text strong style={{ fontSize: 13 }}>نقش‌ها و بازه‌ها</Text>
          <div style={{ marginTop: 4 }}>
            {secondaryRoles.map((r) => <Tag key={r} color="magenta">{r}</Tag>)}
          </div>
          <Text type="secondary" style={{ fontSize: 11 }}>
            مبلغ و بازهٔ این نقش‌ها در «ویرایش پرسنل ← اطلاعات حقوقی ← نقش‌ها و بازه‌ها» است.
          </Text>
        </div>
      )}

      {conflict && <Alert type="warning" showIcon message={conflict} />}
    </div>
  );
}
